import APIController from '../core-api-controller';

//Listing's Api

export const fetchUsersApi = (paramsObj = {}, paramsStr = '') => {
  //users table list
  const path = `${APIController.endpointApi}/users${paramsStr ? paramsStr : ''}`;
  return APIController.getApiCallback(path, paramsObj);
};

export const searchUsersApi = (paramsObj = {}, paramsStr = '') => {
  const path = `${APIController.endpointApi}/users/search_users${paramsStr ? paramsStr : ''}`;
  return APIController.getApiCallback(path, paramsObj);
};

export const fetchUserDetailApi = (userId = '') => {
  const path = `${APIController.endpointApi}/users/${userId}`;
  return APIController.getApiCallback(path);
};

export const fetchUserNewApi = () => {
  const path = `${APIController.endpointApi}/users/new`;
  return APIController.getApiCallback(path);
};

export const fetchUsersListApi = (paramsStr = '', paramsObj = {}) => {
  //optimized users list
  const path = `${APIController.endpointApi}/users/list${paramsStr ? paramsStr : ''}`;
  return APIController.getApiCallback(path, paramsObj);
};

export const fetchThirdPartyUsersApi = (paramsStr = '', paramsObj = {}) => {
  //optimized third party users list
  const path = `${APIController.endpointApi}/third_party_users${paramsStr ? paramsStr : ''}`;
  return APIController.getApiCallback(path, paramsObj);
};

export const fetchUserDevicesApi = (id = '', paramsObj = {}) => {
  const path = `${APIController.endpointApi}/users/${id}/fetch_user_devices`;
  return APIController.getApiCallback(path, paramsObj);
};

export const fetchUserLeaveRequestsApi = (id = '', paramsObj = {}) => {
  const path = `${APIController.endpointApi}/users/${id}/leave_requests`;
  return APIController.getApiCallback(path, paramsObj);
};

export const createUserApi = (data = {}) => {
  const path = `${APIController.endpointApi}/users`;
  return APIController.postCallback(path, data);
};

export const updateUserApi = (data = {}, userId = '') => {
  const path = `${APIController.endpointApi}/users/${userId}`;
  return APIController.putCallback(path, data);
};

export const deleteUserApi = (userId = '') => {
  const path = `${APIController.endpointApi}/users/${userId}/deactivate_account`;
  return APIController.putCallback(path);
};

export const userDeviceRevokeApi = (deviceId = '') => {
  const path = `${APIController.endpointApi}/user_devices/${deviceId}/revoke`;
  return APIController.putCallback(path);
};

export const userDeviceUnRevokeApi = (deviceId = '') => {
  const path = `${APIController.endpointApi}/user_devices/${deviceId}/unrevoke`;
  return APIController.putCallback(path);
};

export const userallDevicesRevokeApi = (userId = '') => {
  const path = `${APIController.endpointApi}/users/${userId}/revoke_user_devices`;
  return APIController.putCallback(path);
};

export const userAllDevicesUnRevokeApi = (userId = '') => {
  const path = `${APIController.endpointApi}/users/${userId}/unrevoke_user_devices`;
  return APIController.putCallback(path);
};

export const activateAccountApi = (id = '') => {
  const path = `${APIController.endpointApi}/users/${id}/activate_account`;
  return APIController.putCallback(path);
};

export const deactivateAccountApi = (id = '') => {
  const path = `${APIController.endpointApi}/users/${id}/deactivate_account`;
  return APIController.putCallback(path);
};

export const confirmEmailManuallyApi = (id = '') => {
  const path = `${APIController.endpointApi}/users/${id}/confirm_email_manually`;
  return APIController.putCallback(path);
};

export const fetchUserSaleStats = (id = '') => {
  const path = `${APIController.endpointApi}/users/${id}/fetch_sale_statistics`;
  return APIController.getApiCallback(path);
};

export const fetchUserAffiliateInfoApi = (id = '') => {
  const path = `${APIController.endpointApi}/users/${id}/affiliate_info`;
  return APIController.getApiCallback(path);
};

export const fetchUsersConfirmEmail = (params = {}) => {
  const path = `${APIController.endpointApi}/client_user/users/confirm_email`;
  return APIController.getExternalApiCalllback(path, params, null, null);
};

//user columns api

export const updateUserColumnsApi = (data = {}) => {
  const path = `${APIController.endpointApi}/users/update_user_columns`;
  return APIController.postCallback(path, data);
};
